var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.76,
    height: 13.705,
    viewBox: "0 0 14.76 13.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M16.449,8.119H11.6L10.131,3.724a.534.534,0,0,0-1,0L7.656,8.119H2.777a.529.529,0,0,0-.527.527.387.387,0,0,0,.01.089.506.506,0,0,0,.221.372l3.983,2.807L4.935,16.359a.529.529,0,0,0,.181.593.51.51,0,0,0,.3.128.646.646,0,0,0,.329-.119L9.63,14.191l3.888,2.771a.617.617,0,0,0,.329.119.473.473,0,0,0,.293-.128.522.522,0,0,0,.181-.593l-1.529-4.444,3.95-2.833.1-.082a.5.5,0,0,0-.389-.88Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#ffd62c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingFill);
export default __webpack_public_path__ + "static/media/ratingFill.383f64ef4e366d4cebe666a9ff3c8868.svg";
export { ForwardRef as ReactComponent };